var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"15","height":"17","viewBox":"0 0 15 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.2718 0H1.92451e-07V17H15V2.85386C15 1.27808 13.3304 0 11.2718 0Z","fill":"#EA3CBE"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }